<template>
  <div id="app"  :class="$route.name">

    <header id="header">
      <div class="menu-toggle" @click="mobileMenuChange">
      <div class="hamburger" ref="hamburger">
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
      </div>
    </div>
    <nav id="main-nav" :class="$route.name" ref="mainNav">
      <span class="header-logo-wrapper"><router-link :to="{ name: 'homepage'}"><img src="./assets/img/LOGO.svg?ver=1" id="header-logo"></router-link></span>
    <ul>  
      <li><router-link :to="{ name: 'homepage'}">Home</router-link></li>
      <li><router-link :to="{ name: 'project'}">Inwestycja</router-link></li>
      <li><router-link :to="{ name: 'location'}">Lokalizacja</router-link></li>
      <li><router-link :to="{ name: 'flats'}">Mieszkania</router-link></li>
      <li><router-link :to="{ name: 'about'}">O nas</router-link></li>
      <li><router-link :to="{ name: 'gallery'}">Galeria</router-link></li>
      <li><router-link :to="{ name: 'finances'}">Finansowanie</router-link></li>
      <li><router-link :to="{ name: 'kontakt'}">Kontakt</router-link></li>
    </ul>
    </nav>

    </header>
    <transition
            name="fade"
            mode="out-in"
    >
    <router-view />
    </transition>
    <section class="section footer">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-one-third">
            <h2 class="title">Helvetia City sp. z o.o.</h2>
            <p>

               ul. Jutrzenki 3/70<br>
20-538 Lublin
            </p><br>
            <p><a href="mailto:sprzedaz@kaczencova.pl"><font-awesome-icon icon="envelope" /> sprzedaz@kaczencova.pl</a></p>
            <p><a href="tel:817108027"><font-awesome-icon icon="phone" /> 81 710 80 27</a></p>
            <p><a href="tel:789151482"><font-awesome-icon icon="phone" /> 789 151 482 </a></p>
          </div>
          <div class="column is-one-third footer-gallery">
            <h2 class="title"><router-link :to="{ name: 'gallery'}">GALERIA</router-link></h2>
            <router-link :to="{ name: 'gallery'}"><GalleryComponent /></router-link>
          </div>
          <div class="column is-one-third">
            <ul id="footer-menu">
              <li><router-link :to="{ name: 'homepage'}">HOME</router-link></li>
              <li><router-link :to="{ name: 'project'}">INWESTYCJA</router-link></li>
              <li><router-link :to="{ name: 'location'}">LOKALIZACJA</router-link></li>
              <li><router-link :to="{ name: 'about'}">O NAS</router-link></li>
              <li><router-link :to="{ name: 'gallery'}">GALERIA</router-link></li>
              <li><router-link :to="{ name: 'finances'}">FINANSOWANIE</router-link></li>
              <li><router-link :to="{ name: 'kontakt'}">KONTAKT</router-link></li>
            </ul>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full disclaimer">
            <p>Helvetia City sp. z o.o. © 2023 Wszystkie prawa zastrzeżone.</p>
            <p>Niniejsze informacje zamieszczone na stronie, nie stanowią oferty handlowej w rozumieniu art. 66, ust. 1 Kodeksu Cywilnego.</p>

            <p>Przedstawione wizualizacje mają charakter poglądowy.<br>Wygląd budynku jak również zagospodarowanie terenu mogą ulec zmianie na etapie realizacji inwestycji.</p>
            <p><br><router-link :to="{ name: 'privacy'}">Polityka prywatności</router-link></p>
          </div>

        </div>
      </div>


    </section>


  </div>
</template>

<script>
  import GalleryComponent from '@/components/GalleryCoolbox.vue';
  import Vue from 'vue';
  import VueAnimateOnScroll from 'vue-animate-onscroll';
  Vue.use(VueAnimateOnScroll);


  export default {
    name: "App",
    components :  { GalleryComponent },
    mounted : function() {
      
    },
    computed: {
      currentRouteName() {
        return this.$route.name;
      }
    },
    methods: {
           mobileMenuChange() {
            this.$refs.hamburger.classList.toggle("change");
            this.$refs.mainNav.classList.toggle("open");
           }
        }
  }
</script>

<style lang="scss">

  @import "assets/css/style.scss";


</style>
